import React, { useEffect, useState } from 'react';
import axios from 'axios';
import "./EditeProfileForm.css";
import CustomInput from '../CustomInput/CustomInput';
import CustomBtn from '../CustomBtn/CustomBtn';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

function EditProfileForm() {
    const userinfo = useSelector((state) => state);
      const { currentLocal } = useSelector((state) => state.currentLocal);
  const [grade, setGrade] = useState('')
  const [grade_category, setGrade_category] = useState('')
  const [formData, setFormData] = useState({
    name:userinfo.auth.userArray.user.name,
    phone:userinfo.auth.userArray.user.phone,
    gender: "",
    email:userinfo.auth.userArray.user.email,
  });

const [loading,setLoading]=useState(false)

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleGenderChange = (selectedOption) => {
    setFormData({ ...formData, gender: selectedOption.value });
  };
    useEffect(() => {
  const getFinance=async()=>{
            await axios
                .post(`https://nanosoft.space/taarteb/public/api/user/auth/me`,{}, {
                    headers: {
                        Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                    }
                })
                .then(async (res) => {

setGrade(res.data.data.student.grade.name)
setGrade_category(res.data.data.student.grade.grade_category.name)
      setFormData({
        name: res.data.data.name || "",
        email: res.data.data.email || "",
      });

    // setUpdatedPayments(res.data.data)

                })
                .catch((error) => {

                    



                });


  }
  getFinance()
  }, [])

  const options = [
    { value: 'f', label:currentLocal.home.female },
    { value: 'm', label:currentLocal.home.male},
  ];
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      const response = await axios.post('https://nanosoft.space/taarteb/public/api/user/update-profile', formData,{
        headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      });
      
          toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
      setLoading(false)

    } catch (error) {
      toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });
      setLoading(false)

    }
  };

  return (
    <div className="edit_profile_form_container">
                <ToastContainer/>
        <p>{grade_category+" "+grade}</p>
      <form className="form_container mx-2" onSubmit={handleSubmit}>
        <div>
          <label>{currentLocal.home.namePlaceholder}</label>
          <CustomInput
            type="text"
            name='name'
            value={formData.name}
            onChange={handleChange}
          />
        </div>
{userinfo.auth.userArray.user.phone&&
        <div>
          <label>{currentLocal.home.phonePlaceholder} </label>
          <CustomInput
            type="tel"
            name='phone'
            value={formData.phone}
            onChange={handleChange}
          />

        </div>
}
        <div>
          <label>{currentLocal.home.emailPlaceholder}  </label>
          <CustomInput
            name='email'
            value={formData.email}
            onChange={handleChange}
          />
        </div>



        <div className='d-flex justify-content-center mt-4 '>
                <div className='w-75 d-flex justify-content-center'>
                  <CustomBtn text={loading ? currentLocal.home.Loading :currentLocal.home.Save} disabled={loading} clickingFunction={handleSubmit}customWidth={"100%"}  />

                </div>
              </div>
                    </form>
    </div>
  );
}

export default EditProfileForm;
